/* eslint-disable @typescript-eslint/no-explicit-any */
import { ROLES } from '@config/constants/roles';
import { apiClient } from '@lib/api-client';
import { useAuthorization } from '@lib/authorization';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from 'shared/interfaces/site';

export const getSites = (
	params: any
): Promise<ApiResponse> => {
	return apiClient.get('/sites', {
		params: {
			pageSize: 100,
			query: params.queryParams,
			search: params.searchParams,
			searchFields: ['name'],
			populate: ['project', 'organization', 'entity'],
			sort: 'name',
		},
	});
};

export const useSites = (
	queryParams?: any,
	searchParams?: any
) => {
	const { checkRole } = useAuthorization();

	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['sites', { queryParams, searchParams }],
		queryFn: () =>
			getSites({ queryParams, searchParams }),
		enabled: !checkRole([
			ROLES.PRODUCER_ADMIN,
			ROLES.PRODUCER_STAFF,
		]),
	});
	const updateList = (sites: any) =>
		sites && Array.isArray(sites)
			? sites.reduce((acc: any, currentItem: any) => {
					const modifiedItem = {
						...currentItem,
					};
					acc.push(modifiedItem);

					return acc;
				}, [])
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
